/*undefined*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.QuoteAvailableSubletFilter = (function() {

    /**
     * Namespace QuoteAvailableSubletFilter.
     * @exports QuoteAvailableSubletFilter
     * @namespace
     */
    var QuoteAvailableSubletFilter = {};

    QuoteAvailableSubletFilter.QuoteAvailableSubletFilter = (function() {

        /**
         * Properties of a QuoteAvailableSubletFilter.
         * @memberof QuoteAvailableSubletFilter
         * @interface IQuoteAvailableSubletFilter
         * @property {string|null} [countryId] QuoteAvailableSubletFilter countryId
         * @property {string|null} [query] QuoteAvailableSubletFilter query
         * @property {string|null} [sortColumn] QuoteAvailableSubletFilter sortColumn
         * @property {string|null} [sortOrder] QuoteAvailableSubletFilter sortOrder
         * @property {number|null} [pageIndex] QuoteAvailableSubletFilter pageIndex
         * @property {number|null} [pageSize] QuoteAvailableSubletFilter pageSize
         */

        /**
         * Constructs a new QuoteAvailableSubletFilter.
         * @memberof QuoteAvailableSubletFilter
         * @classdesc Represents a QuoteAvailableSubletFilter.
         * @implements IQuoteAvailableSubletFilter
         * @constructor
         * @param {QuoteAvailableSubletFilter.IQuoteAvailableSubletFilter=} [p] Properties to set
         */
        function QuoteAvailableSubletFilter(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * QuoteAvailableSubletFilter countryId.
         * @member {string|null|undefined} countryId
         * @memberof QuoteAvailableSubletFilter.QuoteAvailableSubletFilter
         * @instance
         */
        QuoteAvailableSubletFilter.prototype.countryId = null;

        /**
         * QuoteAvailableSubletFilter query.
         * @member {string|null|undefined} query
         * @memberof QuoteAvailableSubletFilter.QuoteAvailableSubletFilter
         * @instance
         */
        QuoteAvailableSubletFilter.prototype.query = null;

        /**
         * QuoteAvailableSubletFilter sortColumn.
         * @member {string|null|undefined} sortColumn
         * @memberof QuoteAvailableSubletFilter.QuoteAvailableSubletFilter
         * @instance
         */
        QuoteAvailableSubletFilter.prototype.sortColumn = null;

        /**
         * QuoteAvailableSubletFilter sortOrder.
         * @member {string|null|undefined} sortOrder
         * @memberof QuoteAvailableSubletFilter.QuoteAvailableSubletFilter
         * @instance
         */
        QuoteAvailableSubletFilter.prototype.sortOrder = null;

        /**
         * QuoteAvailableSubletFilter pageIndex.
         * @member {number|null|undefined} pageIndex
         * @memberof QuoteAvailableSubletFilter.QuoteAvailableSubletFilter
         * @instance
         */
        QuoteAvailableSubletFilter.prototype.pageIndex = null;

        /**
         * QuoteAvailableSubletFilter pageSize.
         * @member {number|null|undefined} pageSize
         * @memberof QuoteAvailableSubletFilter.QuoteAvailableSubletFilter
         * @instance
         */
        QuoteAvailableSubletFilter.prototype.pageSize = null;

        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;

        /**
         * QuoteAvailableSubletFilter _countryId.
         * @member {"countryId"|undefined} _countryId
         * @memberof QuoteAvailableSubletFilter.QuoteAvailableSubletFilter
         * @instance
         */
        Object.defineProperty(QuoteAvailableSubletFilter.prototype, "_countryId", {
            get: $util.oneOfGetter($oneOfFields = ["countryId"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * QuoteAvailableSubletFilter _query.
         * @member {"query"|undefined} _query
         * @memberof QuoteAvailableSubletFilter.QuoteAvailableSubletFilter
         * @instance
         */
        Object.defineProperty(QuoteAvailableSubletFilter.prototype, "_query", {
            get: $util.oneOfGetter($oneOfFields = ["query"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * QuoteAvailableSubletFilter _sortColumn.
         * @member {"sortColumn"|undefined} _sortColumn
         * @memberof QuoteAvailableSubletFilter.QuoteAvailableSubletFilter
         * @instance
         */
        Object.defineProperty(QuoteAvailableSubletFilter.prototype, "_sortColumn", {
            get: $util.oneOfGetter($oneOfFields = ["sortColumn"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * QuoteAvailableSubletFilter _sortOrder.
         * @member {"sortOrder"|undefined} _sortOrder
         * @memberof QuoteAvailableSubletFilter.QuoteAvailableSubletFilter
         * @instance
         */
        Object.defineProperty(QuoteAvailableSubletFilter.prototype, "_sortOrder", {
            get: $util.oneOfGetter($oneOfFields = ["sortOrder"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * QuoteAvailableSubletFilter _pageIndex.
         * @member {"pageIndex"|undefined} _pageIndex
         * @memberof QuoteAvailableSubletFilter.QuoteAvailableSubletFilter
         * @instance
         */
        Object.defineProperty(QuoteAvailableSubletFilter.prototype, "_pageIndex", {
            get: $util.oneOfGetter($oneOfFields = ["pageIndex"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * QuoteAvailableSubletFilter _pageSize.
         * @member {"pageSize"|undefined} _pageSize
         * @memberof QuoteAvailableSubletFilter.QuoteAvailableSubletFilter
         * @instance
         */
        Object.defineProperty(QuoteAvailableSubletFilter.prototype, "_pageSize", {
            get: $util.oneOfGetter($oneOfFields = ["pageSize"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Encodes the specified QuoteAvailableSubletFilter message. Does not implicitly {@link QuoteAvailableSubletFilter.QuoteAvailableSubletFilter.verify|verify} messages.
         * @function encode
         * @memberof QuoteAvailableSubletFilter.QuoteAvailableSubletFilter
         * @static
         * @param {QuoteAvailableSubletFilter.IQuoteAvailableSubletFilter} m QuoteAvailableSubletFilter message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        QuoteAvailableSubletFilter.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.countryId != null && Object.hasOwnProperty.call(m, "countryId"))
                w.uint32(10).string(m.countryId);
            if (m.query != null && Object.hasOwnProperty.call(m, "query"))
                w.uint32(18).string(m.query);
            if (m.sortColumn != null && Object.hasOwnProperty.call(m, "sortColumn"))
                w.uint32(26).string(m.sortColumn);
            if (m.sortOrder != null && Object.hasOwnProperty.call(m, "sortOrder"))
                w.uint32(34).string(m.sortOrder);
            if (m.pageIndex != null && Object.hasOwnProperty.call(m, "pageIndex"))
                w.uint32(40).int32(m.pageIndex);
            if (m.pageSize != null && Object.hasOwnProperty.call(m, "pageSize"))
                w.uint32(48).int32(m.pageSize);
            return w;
        };

        /**
         * Encodes the specified QuoteAvailableSubletFilter message, length delimited. Does not implicitly {@link QuoteAvailableSubletFilter.QuoteAvailableSubletFilter.verify|verify} messages.
         * @function encodeDelimited
         * @memberof QuoteAvailableSubletFilter.QuoteAvailableSubletFilter
         * @static
         * @param {QuoteAvailableSubletFilter.IQuoteAvailableSubletFilter} message QuoteAvailableSubletFilter message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        QuoteAvailableSubletFilter.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a QuoteAvailableSubletFilter message from the specified reader or buffer.
         * @function decode
         * @memberof QuoteAvailableSubletFilter.QuoteAvailableSubletFilter
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {QuoteAvailableSubletFilter.QuoteAvailableSubletFilter} QuoteAvailableSubletFilter
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        QuoteAvailableSubletFilter.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.QuoteAvailableSubletFilter.QuoteAvailableSubletFilter();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.countryId = r.string();
                    break;
                case 2:
                    m.query = r.string();
                    break;
                case 3:
                    m.sortColumn = r.string();
                    break;
                case 4:
                    m.sortOrder = r.string();
                    break;
                case 5:
                    m.pageIndex = r.int32();
                    break;
                case 6:
                    m.pageSize = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        /**
         * Decodes a QuoteAvailableSubletFilter message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof QuoteAvailableSubletFilter.QuoteAvailableSubletFilter
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {QuoteAvailableSubletFilter.QuoteAvailableSubletFilter} QuoteAvailableSubletFilter
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        QuoteAvailableSubletFilter.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        return QuoteAvailableSubletFilter;
    })();

    return QuoteAvailableSubletFilter;
})();

module.exports = $root;
